import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

export const StyledInfoLabel = styled.p<SpaceProps>`
	font-size: 0.875rem;
	font-weight: 600;
	margin: 64px 0 23px 0;
	${space}
`;
